export default "__VITE_ASSET__Cop0FXHp__"